import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { getReportDef } from '@app/shared';
import { ReportScreen } from './ReportPage';

/**
 * A page made of several list screens of the engine, one per tab: the reference's pages with
 * sections (Inventory Report, Inventory Reports). `tabs` are [screen key, tab label] pairs.
 */
export function TabbedScreens({
  label,
  tabs,
}: {
  label: string;
  tabs: ReadonlyArray<readonly [key: string, label: string]>;
}) {
  const [tab, setTab] = useState(tabs[0]![0]);
  return (
    <ReportScreen
      // `key` gives each tab its own filters and paging.
      key={tab}
      def={getReportDef(tab)!}
      top={
        <Tabs
          value={tab}
          onChange={(_e, value: string) => setTab(value)}
          aria-label={label}
          sx={{ mb: 1.5, borderBottom: 1, borderColor: 'divider' }}
        >
          {tabs.map(([key, text]) => (
            <Tab key={key} value={key} label={text} />
          ))}
        </Tabs>
      }
    />
  );
}
